module.exports = __webpack_public_path__ + "img/21.925c1e8a.svg";